var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{directives:[{name:"translate",rawName:"v-translate"}],attrs:{"translate-context":"info","translate-params":{ timezone: _vm.timezone }}},[_vm._v(" Time Zone: "),_c('strong',[_vm._v("%{timezone}")])])}
var staticRenderFns = []

export { render, staticRenderFns }